export interface StrokePoint { x: number; y: number; }
export interface StrokeSegment { points: StrokePoint[]; }

export interface SignerState {
    strokes: StrokeSegment[];
    currentStroke: StrokeSegment | null;
    selectedDate: string;
    isDrawEmpty: boolean;
    drawing: boolean;
    lastX: number;
    lastY: number;
    ctx: CanvasRenderingContext2D | null;
}

export interface DocSignState extends SignerState {
    attorney: SignerState;
}

export interface DocDefinition {
    id: string;
    title: string;
    subtitle?: string;
    signerLabel: string;
}

export function blankSigner(): SignerState {
    return {
        strokes: [],
        currentStroke: null,
        selectedDate: '',
        isDrawEmpty: true,
        drawing: false,
        lastX: 0,
        lastY: 0,
        ctx: null,
    };
}
